import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../../service/udnick';

interface IGetCidades {
  codCid: number;
  codUf: number;
  nome: string;
}

export interface IGetCidadesResponse {
  cidades: IGetCidades[];
}

export const SelectCidadeService = {
  getCidades: (codUf?: number): Promise<AxiosResponse<IGetCidadesResponse>> =>
    UDNICK.callService('getCidades', { codUf }),
};
